import { Text, Box, Flex } from "@chakra-ui/react";
import { Modal, Row, Col } from "antd";
import FooterModal from "ui/components/Button/FooterModal";
import { useForm } from "react-hook-form";
import InputMoney from "components/Input/InputMoney/index";
import Field from "components/Input/Field/index";

interface ModalModificarTaxasProps {
  defaultValues: {
    taxaMulta: number;
    taxaJuros: number;
    taxaCobranca: number;
  };
  visible: boolean;
  onClose: () => any;
  onSubmit?: (taxas: {
    taxaMulta: number;
    taxaJuros: number;
    taxaCobranca: number;
  }) => any;
}

function ModalModificarTaxas({
  defaultValues,
  visible,
  onClose,
  onSubmit,
}: ModalModificarTaxasProps) {
  const { control, handleSubmit } = useForm<{
    taxaMulta: number;
    taxaJuros: number;
    taxaCobranca: number;
  }>({
    defaultValues,
  });

  return (
    <Modal
      destroyOnClose
      width="600px"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onSubmit={onSubmit ? handleSubmit(onSubmit) : undefined}
          onClose={onClose}
          showRegisterAnother={false}
          primaryButtonText="Salvar"
        />
      }
      centered
      bodyStyle={{
        borderRadius: 16,
      }}
      className=".antd-rounded-header"
      title={
        <Text fontSize={20} mt={4} fontWeight="bold" as="h3">
          Modificar taxas
        </Text>
      }
      visible={visible}
      onCancel={onClose}
      closable={false}
    >
      <Box>
        <form>
          <Flex flexDir="column">
            <Row gutter={16}>
              <Col xs={8}>
                <Field
                  control={control}
                  name="taxaMulta"
                  label="Taxa de multa(%)"
                  render={({ field, isInvalid }) => (
                    <InputMoney isInvalid={isInvalid} {...field} />
                  )}
                />
              </Col>

              <Col xs={8}>
                <Field
                  control={control}
                  name="taxaJuros"
                  label="Juros ao mês(%)"
                  render={({ field, isInvalid }) => (
                    <InputMoney isInvalid={isInvalid} {...field} />
                  )}
                />
              </Col>

              <Col xs={8}>
                <Field
                  control={control}
                  name="taxaCobranca"
                  label="Taxa de Cobrança(%)"
                  render={({ field, isInvalid }) => (
                    <InputMoney isInvalid={isInvalid} {...field} />
                  )}
                />
              </Col>
            </Row>
          </Flex>
        </form>
      </Box>
    </Modal>
  );
}

export default ModalModificarTaxas;
